var React = require('react');

function ConfettiImg1 (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"4.36806","cy":"4.11475","r":"2.51953","transform":"rotate(-44.2165 4.36806 4.11475)","stroke":"#FFCE54","strokeWidth":"2.43566"}));
}

ConfettiImg1.defaultProps = {"width":"9","height":"8","viewBox":"0 0 9 8","fill":"none"};

module.exports = ConfettiImg1;

ConfettiImg1.default = ConfettiImg1;
